
export class Sponsor {
  id: string;
  salutation: string;
  firstName: string;
  lastname: string;


  constructor(id: string, salutation: string, firstName: string, lastname: string) {
    this.id = id;
    this.salutation = salutation;
    this.firstName = firstName;
    this.lastname = lastname;
  }
}
